<template>
  <ErrorPage type="FORBIDDEN" :hat="message" />
</template>

<script setup lang="ts">
import { ErrorPage } from "@pasta/box-v2";

const message = `Vous n'avez pas accès au parapheur car votre compte n'est pas référencé dans l'annuaire.
Pour obtenir un accès, contactez votre référent ou l'équipe Parapheur.
L'équipe Parapheur`;
</script>
